import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import Modal from "../Modal";
import { SubmitButton } from "@/components/common/SubmitButton";

class SpecialProcessEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schedule_id: this.props.row.schedule_id,
      target: "special_process_text",
      processText: this.props.row.process_text,
      value: "",
      timestamp: this.props.row.timestamp,
      loading: false,

      special_processes: [],
      processesData: [
        { id: 1, name: "high_place_work" },
        { id: 2, name: "heavy_machinery_work" },
        { id: 3, name: "dust_work" },
        { id: 4, name: "radiation_work" },
        { id: 5, name: "inert_work" },
        { id: 6, name: "noisy_work" },
        { id: 7, name: "asbestos_handling_work" },
      ],
    };

    this.handleChangeProcess = this.handleChangeProcess.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    this.props.setUnloadAlert();
    const processes =
      this.props.row.special_process_text == null ? [] : this.props.row.special_process_text.split("\n");

    const processIds = [];
    processes.map((process) => {
      if (process.charAt(0) === "A") {
        processIds.push(1);
      } else if (process.charAt(0) === "B") {
        processIds.push(2);
      } else if (process.charAt(0) === "C") {
        processIds.push(3);
      } else if (process.charAt(0) === "D") {
        processIds.push(4);
      } else if (process.charAt(0) === "E") {
        processIds.push(5);
      } else if (process.charAt(0) === "F") {
        processIds.push(6);
      } else if (process.charAt(0) === "G") {
        processIds.push(7);
      }
    });

    this.setState({
      special_processes: processIds,
    });
  }

  componentWillUnmount() {
    this.props.clearUnloadAlert();
  }

  handleChangeProcess(id, checked) {
    if (checked) {
      this.setState({ special_processes: [...this.state.special_processes, id] });
    } else {
      this.setState({ special_processes: this.state.special_processes.filter((item) => item != id) });
    }
  }

  handleSave() {
    if (this.state.loading) return;
    const { t } = this.props;
    const { processesData, special_processes } = this.state;

    const processStrings = [];

    processesData.map((process, index) => {
      if (special_processes.some((id) => id === process.id)) {
        processStrings.push(t(process.name));
      }
    });

    const data = { ...this.state, value: processStrings.join("\n") };

    data.loading = true;
    this.setState(data);
    this.props.updateItem(
      data,
      () => {
        this.setState({ loading: false });
        this.props.closeHandler();
      },
      () => {
        this.setState({ loading: false });
      }
    );
  }

  render() {
    const { closeHandler, t } = this.props;
    const { processesData, processText } = this.state;

    return (
      <Modal title={`${t("special_work")} ${t("update")}`} closeHandler={() => closeHandler()}>
        <div className="modal-body">
          <div className="form-row mb-0">
            <div className="form-group w-360 txt-center">
              <p className="form-text">{processText ? "[" + processText + "]" : t("no_process_content")}</p>
              <div className="ckbox-vertically w-280">
                {processesData.map((process, index) => (
                  <label key={index} className="ckbox mr-0">
                    <input
                      type="checkbox"
                      value={process.id || undefined}
                      checked={this.state.special_processes.some((value) => value === process.id)}
                      onChange={(e) => this.handleChangeProcess(process.id, e.target.checked)}
                    />
                    <span>{t(process.name)}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className={"modal-footer"}>
          <button
            data-test-id="button-column-editor-cancel"
            type="button"
            className="btn btn-gray"
            onClick={() => closeHandler()}
          >
            {t("cancel")}
          </button>
          <SubmitButton
            data-test-id="button-column-editor-save"
            onClick={this.handleSave}
            loading={this.state.loading}
          />
        </div>
      </Modal>
    );
  }
}

SpecialProcessEditor.propTypes = {
  closeHandler: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  setUnloadAlert: PropTypes.func.isRequired,
  clearUnloadAlert: PropTypes.func.isRequired,
};

export default withTranslation()(SpecialProcessEditor);
